var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.fullscreenDisplay)?_c('div',[_vm._t("default")],2):_c('v-dialog',{attrs:{"eager":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }